export const environment = {
    production: true,
    api: 'https://api.derenda.app/api',
    apiPublic: 'https://api.derenda.app'
};
